export const AddressBook = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2532_67067)">
        <path
          d="M42.5 45C48.0228 45 52.5 40.5228 52.5 35C52.5 29.4772 48.0228 25 42.5 25C36.9772 25 32.5 29.4772 32.5 35C32.5 40.5228 36.9772 45 42.5 45Z"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 22.5H17.5"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 40H17.5"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 57.5H17.5"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.5 52.5C29.2465 50.1713 31.5112 48.2813 34.1147 46.9795C36.7183 45.6777 39.5892 45 42.5 45C45.4108 45 48.2817 45.6777 50.8853 46.9795C53.4888 48.2813 55.7535 50.1713 57.5 52.5"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M67.5 67.5V12.5C67.5 11.1193 66.3807 10 65 10L20 10C18.6193 10 17.5 11.1193 17.5 12.5V67.5C17.5 68.8807 18.6193 70 20 70H65C66.3807 70 67.5 68.8807 67.5 67.5Z"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2532_67067">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
